import {Vue} from 'ui.vue';

import "./BXmakerAuthuserphoneSimpleEmail.styl";

Vue.component('BXmakerAuthuserphoneSimpleEmail', {
    name: 'BXmakerAuthuserphoneSimpleEmail',
    data() {
        return {};
    },
    computed: {},
    methods: {
        onInputEmail(value){
            this.$root.setEmail(value);
        },
        onEnterEmail(value){
            this.$root.setEmail(value);
            this.onClickDone();
        },
        onClickDone(){
            this.$root.startConfirmEmailCode();
        }
    },

    //language=Vue
    template: `
      <div class="bxmaker-authuserphone-simple-email">

        <BXmakerAuthuserphoneHeader>
          {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_EMAIL_TITLE}}
        </BXmakerAuthuserphoneHeader>

        <div class="bxmaker-authuserphone-simple-email__subtitle">
          {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_EMAIL_SUBTITLE}}
        </div>

        <BXmakerAuthuserphoneMessage :message="$root.message" :error="$root.error"/>

        <BXmakerAuthuserphoneInput 
             :title="$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_EMAIL_INPUT"
             :value="$root.email"
             @onInput="onInputEmail"
             @onEnter="onEnterEmail"
             name="EMAIL"             
             type="email"
        />

        <BXmakerAuthuserphoneCaptcha
            :code="$root.captchaCode"
            :src="$root.captchaSrc"
            :length="$root.captchaLength"
            :loader="$root.captchaLoader"
            @onInput="$root.setCaptchaCode"
            @onComplete="onClickDone"
            @onRefresh="$root.refreshCaptcha"
        />


        <BXmakerAuthuserphoneButton
            :title="$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_EMAIL_BUTTON"
            :loader="$root.startLoader"
            @onClick="onClickDone"
        />

      </div>
    `,
});